/*
 * Blur-up placeholders for product gallery images.
 *
 * The wrapper carries a tiny (40px) copy of the image as a blurred CSS
 * background. The real image fades in over it once decoded.
 *
 * Nothing is hidden by CSS alone: `is-pending` — the class that makes the
 * real image transparent — is only ever added by this script, and only to
 * images that have not finished loading. If this file fails to run, every
 * image simply shows as normal with no placeholder. Hiding images by
 * default and revealing them with JS would turn any script error into a
 * page of blank boxes.
 */
(function () {
  var SELECTOR = '.media--blur-up';

  function settle(wrapper) {
    wrapper.classList.remove('is-pending');
    wrapper.classList.add('is-loaded');
  }

  function watch(wrapper) {
    if (wrapper.dataset.blurUpBound === 'true') return;
    wrapper.dataset.blurUpBound = 'true';

    var img = wrapper.querySelector('img');
    if (!img) return;

    // Already decoded (cache, or parsed before this script ran): show it
    // straight away, so a cached image never flashes its placeholder.
    if (img.complete && img.naturalWidth > 0) {
      wrapper.classList.add('is-loaded');
      return;
    }

    wrapper.classList.add('is-pending');
    img.addEventListener('load', function () { settle(wrapper); }, { once: true });
    // A broken image should reveal the browser's own indicator, not sit
    // behind a placeholder for ever.
    img.addEventListener('error', function () { settle(wrapper); }, { once: true });
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
